export const apiPaths = {
  accesskey: {
    search: '/v1/mgmt/accesskey/search',
    deleteBatch: '/v1/mgmt/accesskey/delete/batch',
    create: '/v1/mgmt/accesskey/create',
    deactivate: '/v1/mgmt/accesskey/deactivate/batch',
    activate: '/v1/mgmt/accesskey/activate/batch',
  },
  tenant: {
    roles: '/v1/mgmt/role/all',
  },
};
